<template>
  <el-container
    id="container-teamBuying-editor"
    class="is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div
          style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;"
        >
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item :to="{ path: '/teamBuying', query:{page:$route.query.frompage || 1} }">團購列表 P{{$route.query.frompage || 1}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading" :element-loading-text="loadingHint">

        <el-form label-width="90px" @submit.native.prevent style="margin-top: 40px;">

        <!-- <el-tabs value="common" type="card">
          <el-tab-pane label="通用" name="common"> -->
            <el-form-item label="合作部落客">
              <el-select v-model="form.BloggerUserIDs" multiple placeholder="請選擇部落客" class="left" :readonly="isEdit" :disabled="isEdit">
                <el-option v-for="user in bloggers" :key="user.ID" :value="user.ID" :label="user.Profile.Name"></el-option>
              </el-select>
              <p class="hint">若有合作部落客，每一部落客會獨立一個網址。若無合作部落客，則僅有一個團購專屬網址。</p>
              <el-button v-show="form.BloggerUserIDs.length" size="mini" class="left" @click="isShowAllURLs=true">檢視網址</el-button>
            </el-form-item>

            <el-form-item label="開團時間">
              <el-date-picker v-model="form.BeginAt" class="left" type="datetime" placeholder="請選擇開團時間"></el-date-picker>
            </el-form-item>
            <el-form-item label="結團時間">
              <el-date-picker v-model="form.EndAt" class="left" type="datetime" placeholder="請選擇結團時間"></el-date-picker>
            </el-form-item>
            <el-form-item label="發佈日期">
              <el-date-picker v-model="form.ReleaseAt" class="left" type="date" placeholder="請選擇發佈時間"></el-date-picker>
              <p class="hint">什麼時候開始看得到團購頁面</p>
            </el-form-item>
            <el-form-item label="下架日期">
              <el-date-picker v-model="form.CloseAt" class="left" type="date" placeholder="請選擇開團下架"></el-date-picker>
              <p class="hint">什麼時候之後看不到團購頁面</p>
            </el-form-item>
        <!--
          </el-tab-pane>
        </el-tabs> -->

        <!-- <el-tabs v-model="activeLang" type="card">
          <el-tab-pane label="繁中" name="tw"> -->
            <form-content :form="form" form-key="Tw"
              @title-changed="onTitleChanged"/>
          <!-- </el-tab-pane>
          <el-tab-pane v-if="languages.includes('Cn')" label="簡中" name="cn">
            <form-content :form="form" form-key="Cn"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('En')" label="英文" name="en">
            <form-content :form="form" form-key="En"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('Jp')" label="日文" name="jp">
            <form-content :form="form" form-key="Jp"/>
          </el-tab-pane>
        </el-tabs> -->
        </el-form>

        <p class="auto-save-hint">{{autoSaveHint}}</p>
        <p v-show="!(form.BloggerUserIDs && form.BloggerUserIDs.length)" class="url-hint">{{config.WEBURL}}/team-buying/{{form.URLKey}}</p>

        <!-- <el-switch
          v-model="form.Tw.IsActive"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
        ></el-switch> -->

        <el-tooltip v-if="!isEdit" class="item" effect="dark" placement="top-start">
          <div slot="content">網址路徑為以下: {{config.WEBURL}}/team-buying/{{form.URLKey}}</div>
          <el-button type="primary" class="btn-set-url" size="mini" @click="showURLEditor">設定網址</el-button>
        </el-tooltip>
<!--
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">一鍵翻譯會自動將繁體中文的內容翻譯成其他語言，<br>並且覆蓋資料!<br><br>包含圖片影片也會覆蓋，包含內容編輯器</div>
          <el-button type="primary" class="btn-translate" size="mini" @click="autoTranslate">一鍵翻譯</el-button>
        </el-tooltip> -->

        <el-button type="primary" class="btn-upload" size="mini" @click="submit">
          送出
          <i class="el-icon-upload el-icon--right"></i>
        </el-button>
      </el-main>

      <u-r-l-setting-modal :isShow="isShowUrlSetModal" @close="isShowUrlSetModal = false" :url-key="form.URLKey" @submit="onSetURLKey"/>

      <el-dialog
        title="團購網址"
        :visible.sync="isShowAllURLs"
        width="800px"
        :append-to-body="true">

        <table class="table-team-buying-urls">
          <thead>
            <tr>
              <th>部落客</th>
              <th>團購連結</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="blogger in selectedBloggers" :key="blogger.ID">
              <td>{{blogger.Profile.Name}}</td>
              <td><a target="_blank" :href="`${config.WEBURL}/team-buying/${form.URLKey}-${blogger.Profile.URLKey}`">{{config.WEBURL}}/team-buying/{{form.URLKey}}-{{blogger.Profile.URLKey}}</a></td>
            </tr>
          </tbody>
        </table>

        <span slot="footer" class="dialog-footer">
          <el-button @click="isShowAllURLs = false">關閉</el-button>
        </span>
      </el-dialog>

    </el-container>
  </el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import FormContent from '@/data/teamBuying/view/editor-form.vue'
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
import URLSettingModal from '@/data/teamBuying/view/url-setting-modal.vue'
import MixinOfTranslation from '@/utils/mixin-translate.vue'
import MixinAutoSave from '@/utils/mixin-autosave.vue' // cacheKey required
import { genRandomStr } from '@/utils/random.js'
import Config from '@/assets/js/config.js'

export default {
  mixins: [MixinOfPreventLeaveEditPage, MixinLanguages, MixinOfTranslation, MixinAutoSave],
  components: {
    LeftMenu,
    TopHeader,
    FormContent,
    URLSettingModal
  },
  data () {
    return {
      config: Config,
      oriObj: {},
      form: {
        BloggerUserIDs: [],
        TagID: null,
        Date: moment().format(),
        IsActive: true,
        URLKey: '',
        Tw: { Tags: [], IsActive: true, Date: moment().format() },
        Cn: { Tags: [], IsActive: true, Date: moment().format() },
        En: { Tags: [], IsActive: true, Date: moment().format() },
        Jp: { Tags: [], IsActive: true, Date: moment().format() }
      },
      activeLang: 'tw',
      isLoading: false,
      loadingHint: '',
      // url key
      isShowUrlSetModal: false,
      isURLKeySetManually: false,

      pickerOptions: {
        disabledDate (time) {
          return time.getFullYear() < 2022
        }
      },

      isShowTagAddeditModal: false,
      isShowAllURLs: false
    }
  },
  computed: {
    isEdit () {
      return this.$route.name !== 'createTeamBuying'
    },
    title () {
      return this.isEdit ? this.form.Tw.Title : '新增'
    },
    bloggers () {
      return this.$store.state.user.list.filter(o => o.IsActive && o.AdminLevel == 10)
    },
    selectedBloggers () {
      return this.$store.state.user.list.filter(o => this.form.BloggerUserIDs.includes(o.ID))
    }
  },
  methods: {
    /* url key 設置 */
    onTitleChanged () {
      // if (this.isEdit) return
      // if (!this.isURLKeySetManually) {
      //   this.form.URLKey = this.form.Tw.Title.replace(/\//g, '')
      // }
    },
    onSetURLKey (urlKey) {
      this.isURLKeySetManually = true
      this.form.URLKey = urlKey
    },
    showURLEditor () {
      this.isShowUrlSetModal = true
    },
    /* end url key */
    submit () {
      if (!this.validateInput()) {
        return
      }
      if (this.isImageUploading()) {
        return alert('圖片上傳中，請稍後再送出')
      }

      var payload = JSON.parse(JSON.stringify(this.form))

      delete payload.Tag

      // 通用欄位
      for (let key of this.languages) {
        payload[key].Contents = JSON.stringify(payload[key].contentJsonArr)
        payload[key].contentJsonArr = undefined

        payload[key].IsActive = !!payload['Tw'].IsActive
        // payload[key].IsActive = !!payload.IsActive

        payload[key].Images = JSON.stringify(payload[key].imagesJsonArr)
        if (payload[key].Images === '') payload[key].Images = '[]'
        payload[key].imagesJsonArr = undefined
      }

      this.isLoading = true

      this.loadingHint = '正在上傳資料'

      payload.BloggerUserKeys = payload.BloggerUserIDs.map(id => (this.$store.state.user.list.find(o => o.ID == id) || { Profile: {} }).Profile.URLKey)

      let promise = this.isEdit
        ? this.$services.teamBuying.edit(this, payload)
        : this.$services.teamBuying.add(this, payload)
      promise
        .then(res => {
          let ok = res && res.data && res.data.status === 'ok'
          if (ok) this.onObjAddedit(res)
        })
        .catch(this.$handleServiceError)
        .finally(() => {
          this.isLoading = false
        })
    },
    isImageUploading () {
      for (let lang of this.languages) {
        // 封面圖片
        if (this.form[lang]['coverImageBlob@3x'] && this.form[lang]['coverImageBlob@3x'] instanceof Blob) return true
        if (this.form[lang]['coverImageBlob@2x'] && this.form[lang]['coverImageBlob@2x'] instanceof Blob) return true
        if (this.form[lang]['coverImageBlob@1x'] && this.form[lang]['coverImageBlob@1x'] instanceof Blob) return true

        // 圖片編輯器
        for (let i in this.form[lang].contentJsonArr) {
          let obj = this.form[lang].contentJsonArr[i]
          if (!obj) continue
          if (obj.type === 'image' && obj.value.img instanceof Blob) {
            return true
          }
        }
      }
      return false
    },
    onObjAddedit (res) {
      this.clearCache()
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = {}
      this.$router.push({ name: 'teamBuying-list', query: { page: this.$route.query.frompage || 1 } })
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.teamBuying.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.teamBuying.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.teamBuying.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown teamBuying for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.URLKey) {
        errMsg = '請設定網址'
      } else if (!this.form.Tw.Title) {
        errMsg = '請輸入標題'
      } else if (!this.form.BeginAt) {
        errMsg = '請輸入開團時間'
      } else if (!this.form.EndAt) {
        errMsg = '請輸入結團時間'
      }/* else if (!this.form.Date) {
        errMsg = '請選擇日期'
      } else if (!this.form.TagID) {
        errMsg = '請選擇類別'
      } */

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
        return false
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    },
    // tranlsate
    autoTranslate () {
      this.isLoading = true

      const translateKeys = ['Title', 'SubTitle']
      const syncKeys = ['Images']
      const contentJsonArr = this.form.Tw.contentJsonArr

      this.syncForm(syncKeys)

      // 每一次結束都先設定 isLoading=true，避免其中一個先完成而取消 loading
      let promises1 = this.translateForm(translateKeys).then(() => { this.isLoading = true })
      let promises2 = this.translateContentEditor(contentJsonArr).then(() => { this.isLoading = true })

      // 同步 images
      let langs = this.languages.filter(o => o !== 'Tw')
      let arrClone = this.form['Tw']['imagesJsonArr'] ? JSON.parse(JSON.stringify(this.form['Tw']['imagesJsonArr'])) : []
      for (let lang of langs) {
        this.$set(this.form[lang], 'imagesJsonArr', arrClone)
      }

      Promise.all([promises1, promises2]).then(() => {
        this.isLoading = false
      })
    }
  },
  created () {
    this.$services.user.getAll(this).then(res => {
      this.$store.state.user.list = res.data.result
    }).catch(this.$handleServiceError)

    this.form.URLKey = genRandomStr(10)

    var formSource = null
    let id = parseInt(this.$route.params.id)
    if (id && id > 0) {
      let idx = this.$store.state.teamBuying.list.findIndex(o => o.ID === id)
      if (idx >= 0) {
        this.oriObj = this.$store.state.teamBuying.list[idx]
        formSource = JSON.parse(JSON.stringify(this.oriObj))

        for (let key of this.languages) {
        }
        this.form = formSource
      } else {
        console.error(`unknown teamBuying for id ${id}`)
      }
    }

    // cache
    this.cacheKey = 'cache-teamBuying-' + (this.isEdit ? this.oriObj.ID : 0)
    let cache = this.getCache()
    if (cache) {
      this.confirmLoadCache().then(result => {
        if (result !== 'loaded') return
        let cacheForm = JSON.parse(cache)
        for (let key of this.languages) {
        }
        this.form = cacheForm
      }).catch(err => {
        console.error(err)
      })
    }
  }
}
</script>

<style>
.el-tabs {
  height: 100%;
}
.el-tabs .el-tabs__content {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.el-tab-pane {
  max-width: 1030px;
}
</style>
<style scoped>

.btn-translate {
  position: absolute;
  top: 26px;
  right: 110px;
}

.btn-set-url {
  position: absolute;
  top: 26px;
  right: 205px;
  right: 110px;
}
.switch-deploy {
  position: absolute !important;
  top: 30px;
  right: 300px;
}

.auto-save-hint {
  position: absolute;
  top: 33px;
  right: 424px;
  color: gray;
  font-size: 14px;
  right: 205px;
}

.url-hint {
  position: absolute;
  top: 0;
  left: 20px;
  color: gray;
  font-size: 14px;
}
</style>

<style scoped>
.table-team-buying-urls {

}
.table-team-buying-urls th,
.table-team-buying-urls td {
  text-align: left;
  padding: 3px 5px;
}
</style>
